import { render, staticRenderFns } from "./ruler-edit.vue?vue&type=template&id=5f8c8834&"
import script from "./ruler-edit.vue?vue&type=script&lang=js&"
export * from "./ruler-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports